import React from "react";
import {Brands} from "@core-ui/utility";
import {ResponsiveIcon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandLargeViewBoxSVG = (
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M16 29c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16s5.82 13 13 13Zm0 3c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
      fillRule="evenodd"
    />
    <path d="M14.5 6h3v11h-3z" />
    <path d="m14.5 17 2.121-2.121 4.95 4.95-2.121 2.12z" />
  </svg>
);

const CrossBrandSmallViewBoxSVG = (
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z"
      fillRule="evenodd"
    />
    <path d="M7.25 3h1.5v5h-1.5z" />
    <path d="m7.25 8 1.06-1.06 2.476 2.474-1.061 1.06z" />
  </svg>
);

const brandIconLargeViewBoxSVGs = {
  [Brands.Athleta]: CrossBrandLargeViewBoxSVG,
  [Brands.BananaRepublic]: CrossBrandLargeViewBoxSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandLargeViewBoxSVG,
  [Brands.Gap]: CrossBrandLargeViewBoxSVG,
  [Brands.GapFactoryStore]: CrossBrandLargeViewBoxSVG,
  [Brands.OldNavy]: CrossBrandLargeViewBoxSVG,
  crossBrand: CrossBrandLargeViewBoxSVG,
};

const brandIconSmallViewBoxSVGs = {
  [Brands.Athleta]: CrossBrandSmallViewBoxSVG,
  [Brands.BananaRepublic]: CrossBrandSmallViewBoxSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSmallViewBoxSVG,
  [Brands.Gap]: CrossBrandSmallViewBoxSVG,
  [Brands.GapFactoryStore]: CrossBrandSmallViewBoxSVG,
  [Brands.OldNavy]: CrossBrandSmallViewBoxSVG,
  crossBrand: CrossBrandSmallViewBoxSVG,
};

export const ClockIcon = (props: IconContainerProps): JSX.Element => (
  <ResponsiveIcon
    {...props}
    brandIconLargeViewBoxSVGs={brandIconLargeViewBoxSVGs}
    brandIconSmallViewBoxSVGs={brandIconSmallViewBoxSVGs}
  />
);
